module.exports = __webpack_public_path__ + "static/img/bcg3.292ff37b.webp";